import 'custom-event-polyfill'
import 'url-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import App from './App'
import router from './router'
import Loading from 'vue-loading-overlay'

import BootstrapVue from 'bootstrap-vue'

import globals from './globals'
import Popper from 'popper.js'
import firebase from 'firebase/app'
import 'firebase/auth'
import { instance } from './api/setup'
import store from './store'
import { abilitiesPlugin } from '@casl/vue'
import ability from './ability'
import vueDebounce from 'vue-debounce'
import Notifications from 'vue-notification'
// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(Loading)
Vue.use(abilitiesPlugin, ability)
Vue.use(vueDebounce, {
  listenTo: 'input'
})
Vue.use(Notifications)
// Axios setup
Vue.prototype.$http = instance

// Global RTL flag
Vue.mixin({
  data: globals
})

// Setup firebase configs
const firebaseConfig = {
  apiKey: 'AIzaSyAqnhZKpay68r0BUPQ3o2StwHg0j3P6gT4',
  authDomain: 'edusystem-management.firebaseapp.com',
  databaseURL: 'https://edusystem-management.firebaseio.com',
  projectId: 'edusystem-management',
  storageBucket: 'edusystem-management.appspot.com',
  messagingSenderId: '500656321432',
  appId: '1:500656321432:web:2f6d56d3d17308f7dbf1ed',
  measurementId: 'G-0GK6XEJNVM'
}

firebase.initializeApp(firebaseConfig)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
